import {
  BulletedListIcon,
  CheckBoxIcon,
  CodeBlockIcon,
  DividerIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  Heading4Icon,
  Heading5Icon,
  Heading6Icon,
  NumberedListIcon,
  QuoteIcon,
  TextIcon,
} from '@blocksuite/affine-components/icons';
import type { NoteChildrenFlavour } from '@blocksuite/affine-shared/types';
import type { TemplateResult } from 'lit';

export const BUTTON_GROUP_LENGTH = 10;

export type NoteMenuItem = {
  icon: TemplateResult<1>;
  tooltip: string;
  childFlavour: NoteChildrenFlavour;
  childType: string | null;
};

const LIST_ITEMS = [
  {
    flavour: 'affine:list',
    type: 'bulleted',
    name: 'Bulleted List',
    description: 'Uma lista com marcadores.',
    icon: BulletedListIcon,
    tooltip: 'Arraste ou clique para inserir uma lista com marcadores',
  },
  {
    flavour: 'affine:list',
    type: 'numbered',
    name: 'Numbered List',
    description: 'Uma lista numerada.',
    icon: NumberedListIcon,
    tooltip: 'Arraste ou clique para inserir uma lista numerada',
  },
  {
    flavour: 'affine:list',
    type: 'todo',
    name: 'To-do List',
    description: 'Acompanhe tarefas em uma lista.',
    icon: CheckBoxIcon,
    tooltip: 'Arraste ou clique para inserir uma lista de tarefas',
  },
];

const TEXT_ITEMS = [
  {
    flavour: 'affine:paragraph',
    type: 'text',
    name: 'Text',
    description: 'Comece a escrever com texto simples.',
    icon: TextIcon,
    tooltip: 'Arraste ou clique para inserir um bloco de texto',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h1',
    name: 'Heading 1',
    description: 'Título de nível 1.',
    icon: Heading1Icon,
    tooltip: 'Arraste ou clique para inserir um título de nível 1',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h2',
    name: 'Heading 2',
    description: 'Título de nível 2.',
    icon: Heading2Icon,
    tooltip: 'Arraste ou clique para inserir um título de nível 2',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h3',
    name: 'Heading 3',
    description: 'Título de nível 3.',
    icon: Heading3Icon,
    tooltip: 'Arraste ou clique para inserir um título de nível 3',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h4',
    name: 'Heading 4',
    description: 'Título de nível 4.',
    icon: Heading4Icon,
    tooltip: 'Arraste ou clique para inserir um título de nível 4',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h5',
    name: 'Heading 5',
    description: 'Título de nível 5.',
    icon: Heading5Icon,
    tooltip: 'Arraste ou clique para inserir um título de nível 5',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h6',
    name: 'Heading 6',
    description: 'Título de nível 6.',
    icon: Heading6Icon,
    tooltip: 'Arraste ou clique para inserir um título de nível 6',
  },
  {
    flavour: 'affine:code',
    type: 'code',
    name: 'Code Block',
    description: 'Adicione um trecho de código.',
    icon: CodeBlockIcon,
    tooltip: 'Arraste ou clique para inserir um bloco de código',
  },
  {
    flavour: 'affine:paragraph',
    type: 'quote',
    name: 'Quote',
    description: 'Adicione uma citação.',
    icon: QuoteIcon,
    tooltip: 'Arraste ou clique para inserir uma citação',
  },
  {
    flavour: 'affine:divider',
    type: null,
    name: 'Divider',
    description: 'Um separador visual.',
    icon: DividerIcon,
    tooltip: 'Um separador visual',
  },
];

// TODO: add image, bookmark, database blocks
export const NOTE_MENU_ITEMS = TEXT_ITEMS.concat(LIST_ITEMS)
  .filter(item => item.name !== 'Divider')
  .map(item => {
    return {
      icon: item.icon,
      tooltip:
        item.type !== 'text'
          ? item.tooltip.replace('Drag/Click to insert ', '')
          : 'Texto',
      childFlavour: item.flavour as NoteChildrenFlavour,
      childType: item.type,
    } as NoteMenuItem;
  });
